import styled from "@emotion/styled";
import type { FC } from "react";
import { default as React } from "react";
import translate from "src/lib/translate";
import { TrackEvent, TrackType } from "src/state/Track/TrackCubit";
import { AppQueryPopupsController } from "src/ui/components/AppQueryPopups/AppQueryPopupsBloc";
import Glp1RefillForm from "src/ui/components/Gpl1RefillForm/Glp1RefillForm";
import InDialog from "src/ui/components/InDialog/InDialog";
import Track from "src/ui/components/Track/Track";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";

const WidthConstraint = styled.div`
  width: 100%;
  max-width: 28rem;
  margin: 0 auto;
`;

const GLP1RefillDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();
  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  return (
    <InDialog
      title={translate("glp1RefillDialog.title")}
      onClose={onClose}
      returnUrl={returnUrl}
      width="min(calc(100% - 4rem), 120rem)"
      height="min(calc(100% - 4rem), 70rem)"
    >
      <Track event={TrackEvent.GLP1RefillDialog} type={TrackType.open} />
      <WidthConstraint>
        <Glp1RefillForm onComplete={onClose} />
      </WidthConstraint>
    </InDialog>
  );
};

export default GLP1RefillDialog;
